import { Injectable } from '@angular/core';
import {io, Socket} from "socket.io-client";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private socket!: Socket;
  private socketUrl = environment.socketBaseUrl;

  constructor() {
    // Inizializza il socket (sostituisci il placeholder con l’URL del tuo backend)
    this.socket = io(this.socketUrl);
  }

  // Socket per la ricezione di messaggi di creazione
  onCreateMessage(idPrestazione: string | null): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('nuovaPrenotazione', (msg: any) => {
        if (msg.prenotazione.prestazione === idPrestazione) {
          observer.next(msg);
        }
      });
      // Pulizia quando l’observable termina
      return () => {
        this.socket.off('nuovaPrenotazione');
      };
    });
  }

  // Socket per la ricezione di messaggi di aggiornamento
  onUpdateMessage(idPrestazione: string | null): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('updatePrenotazione', (msg: any) => {
        if (msg.prenotazione.prestazione === idPrestazione) {
          observer.next(msg);
        }
      });
      // Pulizia quando l’observable termina
      return () => {
        this.socket.off('updatePrenotazione');
      };
    });
  }

  // Socket per la ricezione di messaggi di eliminazione
  onDeleteMessage(idPrestazione: string | null): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('deletePrenotazione', (msg: any) => {
        if (msg.prenotazione.prestazione === idPrestazione) {
          observer.next(msg);
        }
      });
      // Pulizia quando l’observable termina
      return () => {
        this.socket.off('deletePrenotazione');
      };
    });
  }

}
